import WorkflowStep from "../workflow/workflowStep";
import Guid from "~/helpers/guid";
import FormSection from "./formSection";
import Vue from "vue";
import TrackedArrayProxy from "../trackedArrayProxy";
import {FormSectionValidationMode} from "~/enums/formSectionValidationMode"

export default class FormSectionFactory {
  constructor() {

  }

  static create(workflowStep: WorkflowStep): FormSection {
    const fs: FormSection = new FormSection();

    fs.rootModel = workflowStep.rootModel;
    fs.parent = workflowStep;
    fs.defineProperty('client_id', Guid.create());
    FormSection.repo.add(fs);
    Vue.set(workflowStep, 'form_section', fs);

    const proxyPages = Object.assign([''], {parent: fs, key: 'pages'});
    fs.defineProperty('pages', TrackedArrayProxy.create(proxyPages));
    fs.defineProperty('validation_mode', FormSectionValidationMode.Submit)
    return fs;
  }
}